var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('PageHeadingFullScreen',{attrs:{"src":_vm.headerImage,"srcMobile":_vm.headerImageMobile,"srcLazy":_vm.headerImageLazy,"title":"Events","filter":"brightness(30%) contrast(80%)"}}),_c('NewsletterSection'),_c('ChristmasChoir')],1)}
var staticRenderFns = []

export { render, staticRenderFns }